import Image from 'next/image';
import React from 'react';

import { useCommonData } from '@app/hooks/useCommonData';
import { cn } from '@app/libs/utils';

interface WhoWeAreSectionProps {
  className?: string;
}

export const WhoWeAreSection: React.FC<WhoWeAreSectionProps> = ({ className }) => {
  const { website } = useCommonData();

  return (
    <section className={cn('w-full flex justify-center mt-20', className)}>
      <div className="2xl:w-[90rem] w-full mx-auto px-5">
        <div className="w-full flex flex-col lg:flex-row gap-20 bg-gray-200 rounded-lg items-stretch">
          <div className="flex-1 flex flex-col gap-5 text-left p-15">
            <span className="text-sm font-semibold uppercase text-gray-500">Về chúng tôi</span>
            <h2 className="text-3xl font-medium text-gray-900 leading-[1.1]">{website.tagline}</h2>
            <p className="text-sm text-gray-700 leading-relaxed max-w-3xl">
              PropX là nền tảng giao dịch bất động sản trực tuyến, tập trung vào trải nghiệm an
              toàn, minh bạch và hiệu quả cho người mua, người bán và nhà môi giới.
            </p>

            {/* Info stats (4 cục thông tin) */}
            <div className="grid grid-cols-2 gap-4 mt-2 max-w-3xl">
              {[
                { value: '8+', label: 'Years Experience', icon: '/images/figma/kpi-calendar.svg' },
                {
                  value: '350+',
                  label: 'Chuyên gia nghiên cứu',
                  icon: '/images/figma/kpi-gear.svg',
                },
                {
                  value: '10K+',
                  label: 'Nhà môi giới bất động sản',
                  icon: '/images/figma/kpi-badge.svg',
                },
                { value: '2.5K+', label: 'Tin bán', icon: '/images/figma/kpi-home.svg' },
              ].map(item => (
                <div
                  key={item.label}
                  className="rounded-lg bg-white shadow-sm px-4 py-3 flex items-center gap-3 hover:shadow-md transition-all"
                >
                  <div className="h-9 w-9 rounded-md bg-[#254B86]/10 flex items-center justify-center">
                    <Image src={item.icon} alt={item.label} width={20} height={20} />
                  </div>
                  <div>
                    <div className="text-base font-bold text-gray-900">{item.value}</div>
                    <div className="text-xs text-gray-600">{item.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="">
              <a
                href="#"
                className="inline-flex items-center justify-center rounded-lg px-5 py-3 text-white font-semibold transition-colors hover:opacity-80"
                style={{ backgroundColor: '#254B86' }}
              >
                Tìm hiểu thêm
              </a>
            </div>
          </div>
          <div className="flex-1 inline-flex items-center justify-center relative min-h-full">
            <Image
              src="/images/figma/hero-image-2-7e921d.png"
              alt="Who We Are"
              width={640}
              height={480}
              className="object-contain absolute bottom-0 right-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
